/* SEYUN Sea Moss offer: the free gift line (Better Breathing Guide, real product + automatic 100% discount) follows the number of jars
   in the cart, on every page (loaded by layout/theme.liquid). Rule: 1 guide from 1 jar (every pack); with 0 jars the gift line is removed.
   Every cart line of the gift variant is managed (the gift is only given with this offer). Test override: window.SEYUN_SM_SYNC_CONFIG. */
(() => {
  if (window.__seyunSmSync) return;
  const cfg = Object.assign({
    jars: { '67810808103219': 1 },
    tag: 'seamoss-offer',
    gifts: []   // Cédric 28/10: no free guide on SEYUN US
  }, window.SEYUN_SM_SYNC_CONFIG || {});
  window.__seyunSmSync = true;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const H = { 'Content-Type': 'application/json', Accept: 'application/json' };
  let busy = false, timer, retries = 0;

  const css = document.createElement('style');
  css.id = 'ssm-gift-lock';
  css.textContent = cfg.gifts.map(g => '.moonbundle-cart-item[data-item-key^="' + g.id + ':"] .moonbundle-cart-item-quantity-container,.moonbundle-cart-item[data-item-key^="' + g.id + ':"] .moonbundle-cart-item-remove-container').join(',') + '{display:none!important}';
  document.head.appendChild(css);

  async function readCart() {
    for (let i = 0; i < 4; i++) {
      try {
        const r = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (r.ok) return await r.json();
      } catch (e) {}
      await new Promise(r => setTimeout(r, 1200));
    }
    return null;
  }
  async function post(path, body) {
    const r = await fetch(root + path, { method: 'POST', headers: H, body: JSON.stringify(body) });
    if (!r.ok) throw new Error('cart ' + r.status);
    return r.json();
  }
  async function reconcile() {
    if (busy || window.__ssmBusy) { schedule(600); return; }
    busy = true;
    try {
      const cart = await readCart();
      if (!cart) { if (retries++ < 3) schedule(3000); return; }
      retries = 0;
      const jars = cart.items.reduce((s, i) => s + (cfg.jars[String(i.variant_id)] || 0) * i.quantity, 0);
      let changed = false;
      for (const g of cfg.gifts) {
        const want = jars >= g.min ? (g.max || 1) : 0;
        const lines = cart.items.filter(i => String(i.variant_id) === String(g.id));
        const have = lines.reduce((s, i) => s + i.quantity, 0);
        const tagged = lines.length && lines[0].properties && lines[0].properties._free_gift === cfg.tag;
        if (have === want && (want === 0 || (lines.length === 1 && tagged))) continue;
        if (want > 0 && (!lines.length || !tagged)) {
          for (const l of lines) await post('cart/change.js', { id: l.key, quantity: 0 });
          await post('cart/add.js', { items: [{ id: Number(g.id), quantity: want, properties: { _free_gift: cfg.tag } }] });
        } else if (want > 0) {
          await post('cart/change.js', { id: lines[0].key, quantity: want });
          for (const l of lines.slice(1)) await post('cart/change.js', { id: l.key, quantity: 0 });
        } else {
          for (const l of lines) await post('cart/change.js', { id: l.key, quantity: 0 });
        }
        changed = true;
      }
      if (changed) window.dispatchEvent(new CustomEvent('moonbundle-cart-updated', { detail: { caller: 'seyun-sm-sync' } }));
    } catch (e) { /* silent: never block the shopper */ }
    finally { busy = false; }
  }
  const schedule = (ms) => { clearTimeout(timer); timer = setTimeout(reconcile, ms || 400); };

  const orig = window.fetch;
  window.fetch = function (input) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const p = orig.apply(this, arguments);
    if (!busy && /\/cart\/(change|update|add)(\.js)?(\?|$)/.test(url) && !/moonbundle_ignore/.test(url)) p.then(() => schedule(), () => {});
    return p;
  };
  window.addEventListener('moonbundle-cart-updated', e => { if (!(e.detail && /^seyun-sm-sync/.test(e.detail.caller || ''))) schedule(); });

  /* The "cart" cookie exists only when a cart exists: no network call for shoppers without a cart. */
  if (/(?:^|;\s*)cart=/.test(document.cookie)) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => schedule(200)); else schedule(200);
  }
})();
